import type { LabelAssignment } from '@provision/entity-types';
import { createContext, useContext } from 'react';
import type { FormAutocompleteProps } from 'src/components';
import type { Address } from 'src/graphql';
import type { SidePanelPropertyKey } from 'src/graphql/entities/side-panel-personalization';
import type { AssociatedSiteFormValues } from 'src/pages/Conversations/SidePanel/ConversationDetails/ConversationSite/use-associated-site-form';

export interface SiteCardFormData {
  address: Address;
  disabled: boolean;
  fieldsByKey: Partial<Record<SidePanelPropertyKey, FormAutocompleteProps>>;
  onSubmit: (values: AssociatedSiteFormValues) => void;
  labelAssignments: LabelAssignment[] | undefined;
  canAccessPrivateLabels: boolean;
  isEmptyByKey: Partial<Record<SidePanelPropertyKey, boolean>>;
}

// context and provider live in separate modules (like the custom-attributes
// side-panel pair) so consumers of the hook don't drag the provider's form
// machinery into their import graph
export const SiteCardFormContext = createContext<SiteCardFormData | null>(null);

export function useSiteCardForm(): SiteCardFormData {
  const value = useContext(SiteCardFormContext);

  if (!value) {
    throw new Error('useSiteCardForm must be used within SiteCardFormProvider');
  }

  return value;
}
